import React, { useReducer, useEffect } from 'react';


import PropTypes from 'prop-types';
import AppContext               from 'context/Context';
import { AuthProvider }         from './context/authProvider';
import { settings, PAGE_CONTAINER_MODE } from './config';
import { getColor, getItemFromStore } from 'helpers/utils';
import { configReducer } from './reducers/configReducer';
import useToggleStyle from './hooks/useToggleStyle';
import AuthSuccessHandler from './handlers/AuthSuccessHandler';
// import { request } from './services/api';

/*
| Antd design them
*/
import { ConfigProvider, theme, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

// Global Ant Design loading indicator
Spin.setDefaultIndicator(<LoadingOutlined style={{ fontSize: 24 }} spin />);

// const antdLightConfig = {
//   algorithm: theme.defaultAlgorithm,
//   token: {
//     colorPrimary: '#2c7be5',
//     // colorBgContainer: '#FFFFFF',
//     // colorBgElevated: '#FFFFFF',
//     // colorBgLayout: '#FFFFFF',
//     // colorBgBase: '#FFFFFF',
//     // Menu specific tokens
//     // menuBg: '#FFFFFF',
//     // menuItemBg: '#FFFFFF',
    
//     // Header specific tokens
//     // headerBg: '#FFFFFF',
//     // layoutHeaderBg: '#FFFFFF'
//   },
//   components: {
//     Menu: {
//       // colorItemBg: '#FFFFFF',
//       // colorSubItemBg: '#FFFFFF',
//       // colorBg: "#FFFFFF",
//     },
//     Layout: {
//       // headerBg: '#ccc',
//       // siderBg: '#ccc',
//       // siderBorderColor: '#000',
//     }
//   }
// }



const antdLightConfig = {
  algorithm: theme.defaultAlgorithm,
  token: {
    // colorPrimary: "#2c7be5",
    // colorPrimary: "#316FF6",
    colorPrimary: "#4546ef",
    // colorPrimary: "#7c3ff2",
    // colorDefault: "#000",
    colorBgContainer: "#FFF",
    // colorBgElevated: "#FFFFFF",
    // colorBgLayout: "#ddd",
    colorBgLayout: "#FFF",    // colorBgBase: "#FFFFFF",
    colorBorder: "#ddd",
    borderRadius: 8,
    borderWidth: 1,

    // Menu specific tokens (use --varexe variables for theme/dark mode)
    menuBg: 'var(--varexe-white)',
    menuItemBg: 'var(--varexe-white)',
    menuItemColor: 'var(--varexe-gray-900)',
    menuItemHoverColor: 'var(--varexe-primary)',
    menuItemHoverBg: 'var(--varexe-gray-100)',
    menuItemSelectedColor: 'var(--varexe-primary)',
    menuItemSelectedBg: 'var(--varexe-soft-primary)',
    menuBorderColor: 'var(--varexe-gray-200)',

    // headerBg: "#FFFFFF",
    layoutHeaderBg: 'var(--varexe-white)',
  },
  components: {
    Menu: {
      backgroundColor: 'var(--varexe-white)',
      itemPaddingBlock: 10,
      itemPaddingInline: 15,
      itemHeight: 45,
      groupTitleColor: 'var(--varexe-gray-500)',
      groupTitleFontSize: 14,
      itemHoverBg: 'var(--varexe-gray-200)',
      itemActiveBg: 'var(--varexe-soft-primary)',
      itemSelectedBg: 'var(--varexe-gray-200)',
      subMenuItemBg: 'var(--varexe-gray-100)',
      // border: 'none',
      // borderRadius: 6,
    },
    Layout: {
      headerPadding: 15,
      headerBg: 'var(--varexe-white)',
      siderBg: 'var(--varexe-white)',
    },
    Segmented: {
      trackBg: "#f5f5f5",
      // itemSelectedBg: "#fff",
      itemHoverBg: "#f0f0f0",
      // itemColor: "#333",
      // itemSelectedColor: "#2c7be5",
    },
    Table: {
      headerBorderRadius: 0,
      headerBg: 'transparent',
      headerSortIconColor: "#333",
      headerSortIconColorActive: "#333",
      headerSortIconColorHover: "#333",
      headerSortIconColorActiveHover: "#333",
      headerSortIconColorActiveHover: "#333",

      footerBg: 'transparent',
      footerBorderRadius: 0,

      rowHoverBg: 'var(--varexe-gray-100)',
      borderColor: 'var(--varexe-gray-200)',
      // No background on table body (inherits from page)
      colorBgContainer: 'transparent',
    },
    // Button: {
    //   defaultColor: 'var(--varexe-gray-black)',
    //   defaultBorderColor: 'var(--varexe-gray-black)',
    //   defaultHoverColor: 'var(--varexe-gray-black)',
    //   defaultHoverBorderColor: 'var(--varexe-gray-1000)',
    //   defaultHoverBg: 'var(--varexe-gray-100)',
    //   defaultActiveColor: 'var(--varexe-gray-black)',
    //   defaultActiveBorderColor: 'var(--varexe-gray-1000)',
    //   defaultActiveBg: 'var(--varexe-gray-200)',
    //   textTextColor: 'var(--varexe-gray-black)',
    //   textTextHoverColor: 'var(--varexe-gray-black)',
    //   textTextActiveColor: 'var(--varexe-gray-black)',
    //   textHoverBg: 'var(--varexe-gray-100)',
    // },
  },
};




const antdDarkConfig = {
  "algorithm": theme.darkAlgorithm,
    "token": {
      "colorPrimaryBg": "rgba(245, 245, 245, 0.07)",
      "colorBgContainer": "#0B1727",
      "colorBorder": "#344050",
      "colorBorderSecondary": "#344050",
      "colorBgElevated": "#121E2D",
      "colorBgBase": "#ff0000",
      "colorBgLayout": "#0B1727",
      "colorBgSpotlight": "#497cff"
    },
    "components": {
      Layout: {
        headerPadding: 15,
      },      
      "Segmented": {
        "trackBg": "#1a2332",
        "itemSelectedBg": "#121E2D",
        "itemHoverBg": "#1e2835",
        "itemColor": "#e0e0e0",
        "itemSelectedColor": "#497cff"
      },
      // Button: {
      //   defaultColor: 'var(--varexe-gray-black)',
      //   defaultBorderColor: 'var(--varexe-gray-black)',
      //   defaultHoverColor: 'var(--varexe-gray-black)',
      //   defaultHoverBorderColor: 'var(--varexe-gray-1000)',
      //   defaultHoverBg: 'var(--varexe-gray-100)',
      //   defaultActiveColor: 'var(--varexe-gray-black)',
      //   defaultActiveBorderColor: 'var(--varexe-gray-1000)',
      //   defaultActiveBg: 'var(--varexe-gray-200)',
      //   textTextColor: 'var(--varexe-gray-black)',
      //   textTextHoverColor: 'var(--varexe-gray-black)',
      //   textTextActiveColor: 'var(--varexe-gray-black)',
      //   textHoverBg: 'var(--varexe-gray-100)',
      // },
    }
}

const normalizePageContainerMode = (raw) => {
  if (raw === PAGE_CONTAINER_MODE.BOXED || raw === PAGE_CONTAINER_MODE.FLUID) {
    return raw;
  }
  const fallback = settings.pageContainerMode;
  return fallback === PAGE_CONTAINER_MODE.BOXED || fallback === PAGE_CONTAINER_MODE.FLUID
    ? fallback
    : PAGE_CONTAINER_MODE.BOXED;
};

const Main = props => {
  const configState = {
    isFluid:        getItemFromStore('isFluid', settings.isFluid),
    isRTL:          getItemFromStore('isRTL', settings.isRTL),
    isDark:         getItemFromStore('isDark', settings.isDark),
    developerMode:  getItemFromStore('developerMode', settings.developerMode),
    pageContainerMode: normalizePageContainerMode(
      getItemFromStore('pageContainerMode', settings.pageContainerMode)
    ),
    pageContainer:  settings.pageContainer,
    navbarPosition: getItemFromStore('navbarPosition', settings.navbarPosition),
    isNavbarVerticalCollapsed: getItemFromStore(
      'isNavbarVerticalCollapsed',
      settings.isNavbarVerticalCollapsed
    ),
    navbarStyle: getItemFromStore('navbarStyle', settings.navbarStyle),
    showFooterTools:        getItemFromStore('showFooterTools', settings.showFooterTools),
    currency:               settings.currency,
    showBurgerMenu:         settings.showBurgerMenu,
    showSettingPanel: false,
    navbarCollapsed:  false,
    showNavbarSecondary:    settings.showNavbarSecondary,
    NavbarSecondaryContent: settings.NavbarSecondaryContent,
  };

  const [config, configDispatch] = useReducer(configReducer, configState);

  const { isLoaded } = useToggleStyle(
    config.isRTL,
    config.isDark,
    configDispatch
  );

  const setConfig = (key, value) => {
    configDispatch({
      type: 'SET_CONFIG',
      payload: {
        key,
        value,
        setInStore: [
          'isFluid',
          'isRTL',
          'isDark',
          'developerMode',
          'pageContainerMode',
          'navbarPosition',
          'isNavbarVerticalCollapsed',
          'navbarStyle',
          'showNavbarSecondary',
          'NavbarSecondaryContent',
          'showFooterTools'
        ].includes(key)
      }
    });
  };

  useEffect(() => {
    // request.setContextAccess({ setConfig });
  }, [setConfig]);

  if (!isLoaded) {
    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          backgroundColor: config.isDark ? getColor('dark') : getColor('light')
        }}
      />
    );
  }





  return (
    <AuthProvider>
        <AppContext.Provider value={{ config, setConfig }}>
          <ConfigProvider
              theme={(config.isDark ? antdDarkConfig : antdLightConfig)}
          >
            <AuthSuccessHandler />
            {props.children}
          </ConfigProvider>
        </AppContext.Provider>
    </AuthProvider>
  );
};

Main.propTypes = { children: PropTypes.node };

export default Main;
